import React from 'react';

import {
  useCurrentUser,
  useGiftSubscriptionSettings,
  useGroupSubscription,
} from '../../../../hooks';
import { Spinner } from '../../../BaseUI';
import { CustomToaster } from '../../../BaseUI';
import GiftForm from './GiftForm';
import SubscriptionOverview from './SubscriptionOverview';
import styles from './styles.module.scss';

const Gift = () => {
  const { data: recipients, isLoading } = useGroupSubscription({ type: 'Gift Subscription' });
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const { giftSubscriptionSetting, isGiftSettingsLoading } = useGiftSubscriptionSettings();
  const canAccessGroupSubscription = currentUser?.settings_access_obj?.group_sub_access;

  return (
    <>
      <CustomToaster />
      <>
        {isLoading || isLoadingCurrentUser || isGiftSettingsLoading ? (
          <Spinner />
        ) : (
          <>
            <div className={styles.giftSectionHeader}>
              <div className={styles.settingsSectionHeadingText}>Gift The Information</div>
              <div className={styles.settingsSectionHeadingLine}></div>
            </div>
            <div className={styles.giftSubHeader} id="GiftSubHeader">
              {canAccessGroupSubscription ? (
                <>
                  You can give others access to The Information. Share as a gift or with your
                  team—add additional subscribers for $
                  {giftSubscriptionSetting?.offer?.initialPrice || `199`} a year per person.
                </>
              ) : (
                <>
                  You can give others access to The Information. Share as a gift or with your team.
                  You do not currently have access to this program, but if you would like to get
                  access email{' '}
                  <a className="link-blue" href="mailto:support@theinformation.com">
                    support@theinformation.com
                  </a>
                </>
              )}
            </div>
            {canAccessGroupSubscription && (
              <>
                <div className={styles.giftForms}>
                  <GiftForm />
                </div>
                <div className={styles.giftSectionHeader}>
                  <div className={styles.settingsSectionHeadingText}>Subscriptions</div>
                  <div className={styles.settingsSectionHeadingLine}></div>
                </div>
                <div className={styles.giftSubHeader} id="GiftSubHeader">
                  You are currently supporting the following subscriptions for others to The
                  Information
                </div>
                <SubscriptionOverview recipients={recipients} />
              </>
            )}
          </>
        )}
      </>
    </>
  );
};

export default Gift;
